// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__RY3Ac","text":"SelectPayment_text__3L6y0","title":"SelectPayment_title__3ul8b","btn":"SelectPayment_btn__1Ex9o"};